<template>
    <div>
      <div class="row" v-if="mushroom!==null">
        <div class="form-group col-md-4 text-left">
          ชื่อเห็ดไทย: {{mushroom.mushroom_thai}} <br/>
          ชื่อวิทยาศาสตร์: {{mushroom.mushroom_science}} <br/>
          ประเภทเห็ด: {{getMushroomTypeText(mushroom.mushroom_type)}} <br/>
        </div>
        <div class="form-group col-md-4 text-left">
          ผลการตรวจวิเคราะห์: {{mushroom.analysis_result}} <br/>
          สรุปผลการตรวจวิเคราะห์: {{mushroom.summary_result}} <br/>
          ผู้ตรวจวิเคราะห์: {{mushroom.analyst}} <br/>
          หมายเหตุ: {{mushroom.note}} <br/>
        </div>
        <div class="form-group col-md-4 text-left">
          ข้อมูลพื้นที่พบเห็ด <br/>
          ต.{{mushroom.ttname}} อ.{{mushroom.amname}} จ.{{mushroom.prv_name_th}} <br/>
          ละติจูด: {{mushroom.latitude}}  <br/>
          ลองจิจูด: {{mushroom.longitude}}
        </div>
      </div>
      <div class="row text-center" v-else>
        ไม่พบข้อมูลผลวิเคราะห์
      </div>

      <div class="row">
        <div class="col-md-12">
          <hr/>
        </div>
      </div>

      <form @submit.prevent="saveAlert">
        <div class="row" v-if="mushroom!==null">
          <div class="col-md-3 text-right">แจ้งเตือนไปยังพื้นที่ :</div>
          <div class="col-md-9 text-left">จ.{{mushroom.prv_name_th}}</div>
        </div>
        <div class="row" v-if="mushroom!==null" style="margin-top: 6px;">
          <div class="col-md-3 text-right">ข้อความแจ้งเตือน :</div>
          <div class="col-md-9 text-left">
            <textarea rows="5" style="width: 100%;" v-model="message"></textarea>
          </div>

          <div class="col-md-3 text-right" style="margin-top: 6px;">ภาพประกอบ :</div>
          <div class="col-md-9 text-left" style="margin-top: 6px;">
            <input type="file" id="image" name="image" accept="image/*" />
          </div>
          <div class="col-md-3 text-right" style="margin-top: 6px;">&nbsp;</div>
          <div class="col-md-9 text-right" style="margin-top: 6px;">
            <button type="submit"
                    class="btn btn-success"
            >
              ส่งการแจ้งเตือน
            </button>
          </div>
        </div>
      </form>

    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import { units } from '../units'

  export default {
    name: 'AlertToUser',
    data: function () {
      return {
        analysisid: '',
        mushroom: null,
        message: '',
        pvcode: '',
        prv_id: ''
      }
    },
    mounted: function () {
      this.analysisid = this.$route.params.analysisid
    },
    created () {
      this.analysisid = this.$route.params.analysisid
      this.loadMushroomAnalysisById(this.analysisid)
    },
    computed: {
      ...mapGetters([
        'getBaseUrl',
        'getAuthen'
      ]),
      isLogin () {
        return this.getAuthen.token !== ''
      }
    },
    methods: {
      loadMushroomAnalysisById: function (id) {
        // console.log('loadMushroomAnalysisById id=', id)
        let url = this.getBaseUrl + '/mushroom_analysis_by_id.php'
        let hphId = this.getAuthen.hph_id
        let token = this.getAuthen.token
        const formData = new FormData()
        formData.append('hph_id', hphId)
        formData.append('token', token)
        formData.append('id', id)
        axios.post(url, formData).then(res => {
          let data = res.data
          // console.log(data)
          // this.mushroom_analysis = data
          if (data.length > 0) {
            this.mushroom = data[0]
            this.pvcode = data[0].pvcode
            this.prv_id = data[0].prv_id
            console.log(this.mushroom)
          }
        })
      },
      getMushroomTypeText: function (mushroomType) {
        return units.getMushroomTypeText(mushroomType)
      },
      saveAlert: function (e) {
        try {
          // const file = e.target.files[0]
          if (this.message === '') {
            alert('กรุณากรอกข้อความแจ้งเตือน')
            return
          }
          const file = e.target.image.files[0]
          const name = e.target.image.files[0].name
          // console.log(file)
          // console.log(name)
          // this.item.imageUrl = URL.createObjectURL(file)
          // itemData.append("image1", e.target.image.files[0], e.target.image1.files[0].name);
          let hphId = this.getAuthen.hph_id
          let token = this.getAuthen.token
          const formData = new FormData()
          formData.append('hph_id', hphId)
          formData.append('mushroom_analysis_id', this.analysisid)
          formData.append('token', token)
          formData.append('message', this.message)
          formData.append('pvcode', this.pvcode) // for alert area
          formData.append('prv_id', this.prv_id) // for user
          formData.append('image', file, name)
          // file.name
          let url = this.getBaseUrl + '/mushroom_alert_save.php'
          axios.post(url, formData).then(res => {
            let data = res.data
            // console.log(data)
            if (data.result === 'success') {
              alert('ส่งการแจ้งเตือนเรียบร้อยแล้ว')
              this.$router.push({ path: `/confirmandalert` })
            }
          })
        } catch (e) {
          alert('กรุณาแนบภาพประกอบ')
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AlertToUser.vue?041d27d2